import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    rates: Array,
    savedExchangeId: Number,
  };

  confirm() {
    const event = new CustomEvent(`cortana:rates-confirmed-${this.savedExchangeIdValue}`, {
      bubbles: true,
      detail: {
        confirmedRates: this.ratesValue,
      },
    });

    document.body.dispatchEvent(event);
  }

  cancel() {
    const event = new CustomEvent(`cortana:rates-cancelled-${this.savedExchangeIdValue}`, {
      bubbles: true,
    });

    this.element.dispatchEvent(event);
  }

  change(event) {
    event.currentTarget.classList.toggle("selected");
    const toggledRateId = Number(event.currentTarget.dataset.rateId);
    if (this.ratesValue.includes(toggledRateId)) {
      this.ratesValue = this.ratesValue.filter((rateId) => rateId != toggledRateId);
    } else {
      this.ratesValue = this.ratesValue.concat([toggledRateId]);
    }
  }
}
